<template>
  <SensorDetails v-if="sensorId || createNewSensor" :sensorId="sensorId" :createNew="createNewSensor" />
</template>

<script>
import SensorDetails from '@/components/SensorDetails.vue'

export default {
  name: 'EditSensor',
  components: {
    SensorDetails
  },
  data: () => {
    return {
      sensorId: undefined,
      createNewSensor: false
    }
  },
  mounted() {
    const routeId = this.$route.params.id

    switch(routeId) {
      case "create":
        this.createNewSensor = true
        break
      default:
        this.sensorId = routeId
        break
    }
  }
}
</script>
